<template>
  <v-container fluid>
    <v-row v-if="!isLoading && !errorMessage">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="apiLoading"
          :loading-text="$t('wkt.admin.common.table.loading')"
          :no-data-text="$t('wkt.admin.common.table.no_data')"
          :no-results-text="$t('wkt.admin.common.table.no_results')"
					:footer-props="{
						'items-per-page-options': [20, 50, 100],
						'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
						'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all')
					}"
          class="elevation-0"
          :fixedHeader="true"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" class="mb-3">
              <v-row v-if="!isLoading && !errorMessage">
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="search"
                    :label="$t('wkt.admin.report-types.table.search')"
                    hide-details
                    :clearable="true"
                    @click:clear="searchTimeOut()"
                    @keyup="searchTimeOut()"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

					<template v-slot:[`item`]="{ item }">
						<tr style="cursor: pointer;" @click="editItem(item)">
							<td>{{ item.companyName }}</td>
							<td>{{ item.title }}</td>
							<td>{{ item.module }}</td>
							<td>{{ item.rolesAllowed }}</td>
							<td>{{ item.fields }}</td>
							<td>{{ item.report }}</td>
							<td>{{ item.type == 0 ? 'JASPER' : (item.type == 1 ? 'WEBHOOK' : 'SUPERSET') }}</td>
							<td>{{ item.enabled === true ? $t("wkt.admin.common.yes") : $t("wkt.admin.common.no") }}
							</td>
						</tr>
					</template>

					<template v-slot:[`footer.page-text`]="props">						
						{{ props.pageStart }} - {{ props.pageStop }} {{ $t('wkt.admin.paged-tables.pager.of') }} {{ props.itemsLength > props.pageStop ? `+${props.pageStop}` : props.pageStop }}
					</template>

					<template v-slot:[`footer.prepend`]>
						<RefreshWidget ref="refresh" style="position: fixed;" @refresh="updateData()" />
					</template>
        </v-data-table>
      </v-col>
    </v-row>

		<v-tooltip left>
			<template v-slot:activator="{ on, attrs }">				
				<v-btn dark fixed bottom right fab color="#185EA9" v-bind="attrs" v-on="on" @click="addItem()">
					<v-icon dark>add</v-icon>
				</v-btn>
			</template>
			<span>{{ $t("wkt.admin.report-types.button-add") }}</span>
		</v-tooltip>

    <ReportTypeDialog ref='dlgReportType'/>

    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
        <span style="color: #ffffff;">{{alertText}}</span>
        <v-btn text @click="showAlert=false">
          <span style="color: #ffffff;">Cerrar</span>
        </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-container>
</template>

<script>
import api from '../../api/worktime'
import RefreshWidget from '../common/RefreshWidget'
import ReportTypeDialog from './ReportTypeDialog'

export default {
  name: 'ReportTypeModule',
  components: {
		RefreshWidget, ReportTypeDialog
  },

  data () {
      return { 
        isLoading: false,
				apiLoading: false,
				errorMessage: null,
				showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000,
				search: "",
				options: { itemsPerPage: 20 },
				totalItems: 0,				
        headers: [
          { text: this.$t("wkt.admin.report-types.table.headers.company"), value: 'companyName', width: '15%' },
          { text: this.$t("wkt.admin.report-types.table.headers.title"), value: 'title', width: '15%' },
          { text: this.$t("wkt.admin.report-types.table.headers.module"), value: 'module', width: '10%' },
          { text: this.$t("wkt.admin.report-types.table.headers.roles_allowed"), value: 'rolesAllowed', width: '15%' },
          { text: this.$t("wkt.admin.report-types.table.headers.fields"), value: 'fields', width: '15%' },
          { text: this.$t("wkt.admin.report-types.table.headers.report"), value: 'report', width: '15%' },
          { text: this.$t("wkt.admin.report-types.table.headers.type"), value: 'type', width: '5%' },
          { text: this.$t("wkt.admin.report-types.table.headers.enabled"), value: 'enabled', width: '10%' },
          //{ text: '', value: 'actions', sortable: false, width: '120px' },
        ],
				companies: [],
				items: []
      }
    },
  methods: {
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {				
				this.options.page = 1;
				this.getItems();
			}, 800);
		},
		updateData() {
			this.getItems();
		},
		addItem() {
			this.openDetailDialog(null);
		},
		editItem(item) {
			var me = this;

			api.getReportTypeById(item.id,
				data => {
					me.openDetailDialog(data);
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});			
		},
		openDetailDialog(data) {
			this.$refs.dlgReportType.open(this.companies, data, (message, result) => {
				if (result) {
					this.getItems();
					if (message) {
						this.doShowAlert({ text: message, color: 'success', timeout: 3000 });
					}
				} else {
					if (message) {
						this.doShowAlert({ text: message, color: 'error', timeout: 3000 });
					}
				}
			});
		},
		getItems() {
				//this.isLoading = true;
				this.apiLoading = true;
		
				// eslint-disable-next-line no-unused-vars
				const { sortBy, sortDesc, page, itemsPerPage } = this.options;

				api.getReportTypes((page ? page - 1 : 0) * itemsPerPage, itemsPerPage,  this.search ? this.search : '', sortBy ? sortBy : '', sortDesc,
				data => {
						//this.isLoading = false;
						this.apiLoading = false;
						this.items = data.entities;
						this.totalItems = data.total;

						this.$refs.refresh.update();
				}, err => {
						//this.isLoading = false;
						this.apiLoading = false;
						console.log(err);
						this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
		},
		getCompanies() {
				this.loading = true;

				api.getCompanies(
				data => {
						this.loading = false;
						data.splice(0, 1);
						this.companies = data;
				}, 
				err => {
						this.loading = false;
						console.log(err);
						this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
		},
    onReveal() {
        this.getCompanies();
    }
  }, 
	watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.getItems();
			},
			deep: true,
		},
	},
}
</script>



